// History subsection form field enum
export enum HistoryFormField {
  HISTORY_60_DAY_ER = 'medical-background/history/60-day-er',
  HISTORY_ER_NOTES = 'medical-background/history/er-notes',
  HISTORY_60_DAY_HOSPITAL = 'medical-background/history/60-day-hospital',
  HISTORY_HOSPITAL_NOTES = 'medical-background/history/hospital-notes',
  HISTORY_60_DAY_INJURIES = 'medical-background/history/60-day-injuries',
  HISTORY_INJURY_NOTES = 'medical-background/history/injury-notes',
  HISTORY_60_DAY_FALLS = 'medical-background/history/60-day-falls',
  HISTORY_FALL_NOTES = 'medical-background/history/fall-notes',
  HISTORY_60_DAY_INFECTIONS = 'medical-background/history/60-day-infections',
  HISTORY_INFECTION_NOTES = 'medical-background/history/infection-notes',
  HISTORY_60_DAY_MD = 'medical-background/history/60-day-md',
  HISTORY_MD_NOTES = 'medical-background/history/md-notes',
  HISTORY_FUNCTIONAL_LIMITATIONS = 'medical-background/history/functional-limitations',
  HISTORY_ACTIVITIES_PERMITTED = 'medical-background/history/activities-permitted',
  HISTORY_MEDICAL_HISTORY = 'medical-background/history/medical-history',
  HISTORY_SURGICAL_HISTORY = 'medical-background/history/surgical-history'
}
